import { removelazy, addOrUpdateUrlParam } from './custom';

export function collcollection() {
	var common_estancia = {};
	var common_efe = {};
	var common_esp = {};
	var common_uso = {};
	var common_format = {};

	jQuery( ".coll-product .data-collector" ).each(function( index ) {
		var di = jQuery(this).data('estancia');
let i;
		for ( i=0; i<di.length; i++ ) {
			common_estancia[di[i]]=1;
		}

		di = jQuery(this).data('efecto');
		for ( i=0; i<di.length; i++ ) {
			common_efe[di[i]]=1;
		}

		di = jQuery(this).data('espesor');
		for ( i=0; i<di.length; i++ ) {
			common_esp[di[i]]=1;
		}

		di = jQuery(this).data('uso');
		for ( i=0; i<di.length; i++ ) {
			common_uso[di[i]]=1;
		}

		di = jQuery(this).data('format');
		for ( i=0; i<di.length; i++ ) {
			common_format[di[i]]=1;
		}
	});

	MarkItemForFilter(common_estancia, "estancia") ;
	MarkItemForFilter(common_efe, "efecto") ;
	MarkItemForFilter(common_esp, "espesor") ;
	MarkItemForFilter(common_uso, "uso");
	MarkItemForFilter(common_format, "format");
}

function MarkItemForFilter( arr, type ) {
	jQuery("." + type).addClass("disabled").removeClass("enabled").prop("disabled",true).attr("disabled","disabled");

	for( var i in arr ) {
		jQuery("." + type +"[data-id=" + i +"]" ).addClass("enabled").removeClass("disabled").prop("disabled",false).removeAttr("disabled");
	}
}

if ( typeof window.$GET == "undefined" ) {
	window.$GET = {};

	parseQueryVars();
}

function parseQueryVars() {
	window.location.search.replace(
		new RegExp("([^?=&]+)(=([^&]*))?", "g"),
		function ($0, $1, $2, $3) {
			window.$GET[$1] = $3;
		}
	);
}



export function FetchData(){
	var $term = [];

	jQuery(".filterlist ul").html("");

	var PageURL = window.location.href;

	if ( jQuery(".clicked").length > 0 ) {
		jQuery(".clicked").each( function() {
			$term.push({type: jQuery(this).data("type"), id: jQuery(this).data("id") });
			jQuery(".filterlist ul").append("<li>" + jQuery(this).text() + "</li>");
			PageURL = addOrUpdateUrlParam( PageURL, jQuery(this).data("type"), jQuery(this).data("id") );
		} );

		//window.history.pushState({"pageTitle":"Search Results"}, "", PageURL);

	} else {
		//window.history.pushState({"pageTitle":"Search Results"}, "", window.location.href.split('?')[0]);

	}

	if ( false !== FetchData_callAjax_Ctrl )
		FetchData_callAjax_Ctrl.abort();

	var dataorder = jQuery('.products-all').data('order');
	var dataorderby = jQuery('.products-all').data('orderby');
	var datasearch = jQuery('.products-all').data('search');

	FetchData_callAjax( $term, 6, 0, true, dataorder, dataorderby, datasearch );
}

	var FetchData_callAjax_Ctrl = false;
	function FetchData_callAjax( $term, $size, $offset, $first, $order, $orderby, $search ) {

		var dataorder = jQuery('.products-all').data('order');
		var dataorderby = jQuery('.products-all').data('orderby');
		var datasearch = jQuery('.products-all').data('search');
		collcollection();

		FetchData_callAjax_Ctrl = jQuery.ajax({
			url : tt_custom.ajaxurl,
			method : 'POST',
			data : {
				action : 'changecollection',
				term : $term,
				size : $size,
				offset : $offset,
				first : ( $first ) ? 'yes' : 'no',
				order : $order,
				orderby : $orderby,
				search : $search,
				lang : ( typeof tt_custom !== 'undefined' && tt_custom.lang ) ? tt_custom.lang : '',
				pll_load_front: true
			},

			complete: function( jqXHR, textStatus ) { //jqXHR

				var fade_speed = 'slow';

				if ( textStatus == 'success' && jqXHR.responseText != '' ) {
					if ( $first ) {
						jQuery('.products-all').fadeOut( fade_speed, function() {
							jQuery('.products-all').html( jqXHR.responseText );
							removelazy();
							//collcollection();
							jQuery('.products-all').fadeIn( fade_speed );

							FetchData_callAjax( $term, $size, ( $offset + $size ), false, dataorder, dataorderby, datasearch );

						});

					} else {
						jQuery( jqXHR.responseText ).hide().appendTo('.products-all').fadeIn( fade_speed );
						removelazy();
						//collcollection();

						FetchData_callAjax( $term, $size, ( $offset + $size ), false, dataorder, dataorderby, datasearch );

					}

				} else if ( textStatus == 'success' && jqXHR.responseText == '' && $first ) {
					if ( false !== FetchData_callAjax_Ctrl )
						FetchData_callAjax_Ctrl.abort();

					jQuery('.products-all').html( '<div class="coll-product-error"><p>---</p></div>' );

				}

			}

		});

	}
